export default __webpack_public_path__ + "static/Visiomate_EME_Case_Study-9cc296e12569b8def49e6a4153cc3891.pdf";